import Vue from 'vue';

import { buildFetchMutations } from '@/store/extensions/fetch';
import { buildCreateMutations } from '@/store/extensions/create';
import { buildUpdateMutations } from '@/store/extensions/update';
import { buildDeleteMutations } from '@/store/extensions/delete';

export default {
  ...buildFetchMutations(['fetchPolicy']),
  ...buildCreateMutations(['createPolicy']),
  ...buildUpdateMutations(['acceptPolicy']),
  ...buildDeleteMutations(['deletePolicy']),

  setContext: (state, payload = null) => {
    Vue.set(state, 'context', payload);
  },

  updatePolicyPending: (state) => {
    Vue.set(state, 'processing', true);
  },

  updatePolicySuccess: (state) => {
    Vue.set(state, 'processing', false);
  },

  updatePolicyError: (state) => {
    Vue.set(state, 'processing', false);
  },

  acceptPolicyPending: (state) => {
    Vue.set(state, 'accepting', true);
  },

  acceptPolicySuccess: (state) => {
    Vue.set(state, 'accepting', false);
  },

  acceptPolicyError: (state) => {
    Vue.set(state, 'accepting', false);
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/policy/mutations.js